module.exports = __webpack_public_path__ + "img/shibie2.2a1fecb3.png";